// utils/helmetConfig.js

export const getHelmetConfig = (language) => {
    const configs = {
        uz: {
            home: {
                title: 'TexLab - Laboratoriya Uskunalari | Tez Yetkazib Berish',
                description: 'Laboratoriya uchun eng yaxshi uskunalar. Sertifikatsiya, tez yetkazib berish, 1 yil kafolat. Bosh sahifa.',
                keywords: 'laboratoriya uskunalari, tibbiy asbob-uskunalar, sinov uskunalari, analitik uskunalar'
            },
            shop: {
                title: 'Katalog - Laboratoriya Uskunalari | TexLab',
                description: 'TexLab katalogi. Laboratoriya uskunalarini kategoriyalarda ko\'rish, filtrlab qidiruv, brendlar, narxlar.',
                keywords: 'katalog, laboratoriya, uskunalar, mahsulotlar, kategoriyalar, brendlar, qidiruv'
            },
            about: {
                title: 'Biz Haqimizda | TexLab - Laboratoriya Uskunalari',
                description: 'TexLab - laboratoriya uskunalarining yetakchi yetkazib beruvchisi. 5+ yil tajriba, 1000+ qanoatlangan mijoz, tez yetkazib berish.',
                keywords: 'TexLab, laboratoriya, kompaniya, haqida, uskunalar, tajriba'
            },
            contact: {
                title: 'Aloqa | TexLab',
                description: 'TexLab bilan bog\'laning. Manzil, telefon, email, ijtimoiy tarmoqlar. Biz siz bilan bog\'lanishga tayyormiz.',
                keywords: 'aloqa, telefon, email, manzil, TexLab, bog\'lanish'
            },
            blog: {
                title: 'Yangiliklar | TexLab - Laboratoriya Uskunalari',
                description: 'TexLab yangiliklari. Laboratoriya uskunalari, sertifikatsiya, yangi mahsulotlar, industryaning oxirgi xabarlari.',
                keywords: 'yangiliklar, laboratoriya, uskunalar, xabar, TexLab, blog'
            },
            faqs: {
                title: 'Ko\'p So\'raladigan Savollar | TexLab',
                description: 'TexLab bo\'yicha tez-tez so\'raladigan savollar va ularning javoblari. Yetkazib berish, kafolat, to\'lov, xizmatlar haqida.',
                keywords: 'FAQ, savollar, javoblar, TexLab, yetkazib berish, kafolat, to\'lov'
            },
            services: {
                title: 'Xizmatlar | TexLab',
                description: 'TexLab xizmatlar. Servis markazi, texnik qo\'llab-quvvatlash, konsultatsiya, ta\'lim, sozlash.',
                keywords: 'xizmatlar, servis, qo\'llab-quvvatlash, konsultatsiya, TexLab'
            }
        },
        ru: {
            home: {
                title: 'TexLab - Лабораторное оборудование | Быстрая Доставка',
                description: 'Лучшее оборудование для лаборатории. Сертификация, быстрая доставка, 1 год гарантии. Главная страница.',
                keywords: 'лабораторное оборудование, медицинское оборудование, испытательное оборудование, аналитические приборы'
            },
            shop: {
                title: 'Каталог - Лабораторное оборудование | TexLab',
                description: 'Каталог TexLab. Просмотр лабораторного оборудования по категориям, фильтрованный поиск, бренды, цены.',
                keywords: 'каталог, лаборатория, оборудование, товары, категории, бренды, поиск'
            },
            about: {
                title: 'О Нас | TexLab - Лабораторное оборудование',
                description: 'TexLab - ведущий поставщик лабораторного оборудования. 5+ лет опыта, 1000+ довольных клиентов, быстрая доставка.',
                keywords: 'TexLab, лаборатория, компания, о нас, оборудование, опыт'
            },
            contact: {
                title: 'Контакты | TexLab',
                description: 'Свяжитесь с TexLab. Адрес, телефон, электронная почта, социальные сети. Мы готовы помочь вам.',
                keywords: 'контакты, телефон, email, адрес, TexLab, связь'
            },
            blog: {
                title: 'Новости | TexLab - Лабораторное оборудование',
                description: 'Новости TexLab. Лабораторное оборудование, сертификация, новые товары, последние новости индустрии.',
                keywords: 'новости, лаборатория, оборудование, новость, TexLab, блог'
            },
            faqs: {
                title: 'Часто Задаваемые Вопросы | TexLab',
                description: 'Часто задаваемые вопросы о TexLab. Доставка, гарантия, оплата, услуги и поддержка.',
                keywords: 'FAQ, вопросы, ответы, TexLab, доставка, гарантия, оплата'
            },
            services: {
                title: 'Услуги | TexLab',
                description: 'Услуги TexLab. Сервисный центр, техническая поддержка, консультация, обучение, настройка.',
                keywords: 'услуги, сервис, поддержка, консультация, TexLab'
            }
        }
    };

    return configs[language] || configs['uz'];
};

export default getHelmetConfig;